<template>
  <v-container fluid>
    <page-header>
      <template slot="topRightSlot">
        <v-btn
          depressed
          elevation="0"
          class="ml-2 mb-4"
          color="primary"
          type="button"
          :to="{ name: 'CreateLetterPackage' }"
          >{{ $t('add') }}</v-btn
        >
      </template>
    </page-header>

    <datatable
      :isLoading="tableLoading"
      :tableHeaders="tableHeaders"
      :tableData="tableData"
      :itemTotal="tableTotal"
      :page.sync="tableFilter.page"
      :pageLimit.sync="tableFilter.limit"
      actionViewRouteLink="LetterPackageDetail"
      enableSearch
      enableClearAll
      @options-update="getList()"
      searchPlaceholder="companySearchPlaceholder"
       @search-clicked="search($event)"
      @all-search-cleared="clearSearch()"
    >
      <template slot="custom-toolbar-slot">
        <form-select
          :fieldValue.sync="tableFilter.status"
          hideDetails
          dense
          placeholder="searchStatus"
          :options="statusOptions"
          class="mr-3 mt-2 mb-3"
          enabledClear
          @changed="searchStatus($event)"
        />
      </template>
      <template v-slot:[`item.item_status`]="{ item }">{{ item.item_status ? $t(`letterStatusOptions.${item.item_status}`) : '' }}</template>
      <template v-slot:[`item.type`]="{ item }">{{ $t(`letterTypeOptions.${item.type}`) }}</template>
    </datatable>
  </v-container>
</template>

<script>
import Datatable from '@/components/Datatable.vue'
import FormSelect from '@/components/form/FormSelect.vue'
export default {
  name: 'LetterPackageList',
  components: {
    Datatable,
    FormSelect,
  },
  data: vm => ({
    tableLoading: false,
    tableData: [],
    tableTotal: 0,
    tableFilter: {
      page: 1,
      limit: 10,
      status: '',
      keyword: '',
    },
    tableHeaders: [
      { value: 'receive_date', text: vm.$t('receivedDate'), width: 130 },
      { value: 'company_en', text: vm.$t('companyNameEn') },
      { value: 'company_zh', text: vm.$t('companyNameZh') },
      { value: 'type', text: vm.$t('type') },
      { value: 'item_status', text: vm.$t('status') },
      { value: 'request_date', text: vm.$t('requestLetterActionDate') },
      { value: 'action_date', text: vm.$t('letterActionDate') },
      { value: 'actionView', text: '', align: 'end' },
    ],
    statusOptions: [
      { value: 'pending', text: vm.$t('letterStatusOptions.pending') },
      { value: 'scanned', text: vm.$t('letterStatusOptions.scanned') },
      { value: 'forwarded', text: vm.$t('letterStatusOptions.forwarded') },
      { value: 'picked_up', text: vm.$t('letterStatusOptions.picked_up') },
      { value: 'request_forward', text: vm.$t('letterStatusOptions.request_forward') },
      { value: 'request_scan', text: vm.$t('letterStatusOptions.request_scan') },
      { value: 'request_pick_up', text: vm.$t('letterStatusOptions.request_pick_up') },
    ],
  }),
  methods: {
    async getList(regenUrl = true) {
      if (regenUrl) {
        this.regenerateURL()
      }

      this.tableLoading = true
      try {
        const payload = {
          filter_page: this.tableFilter.page - 1,
          filter_limit: this.tableFilter.limit,
          filters: []
        }

        if (this.tableFilter.keyword) {
          payload['search'] = this.tableFilter.keyword;
        }
        if (this.tableFilter.status) {
          payload.filters.push({ key: 'item_status', value: this.tableFilter.status })
        }

        const { total, data } = await this.$Fetcher.GetLetters(payload)
        this.tableTotal = total
        this.tableData = data
      } catch (err) {
        this.$common.error(err)
        this.tableData = []
      } finally {
        this.tableLoading = false
      }
    },
    search(value) {
      this.tableFilter.keyword = value;
      this.tableFilter.page = 1;
      this.getList();
    },
    clearSearch() {
      this.tableFilter.keyword = '';
      this.tableFilter.status = '';
      this.tableFilter.page = 1;
      this.getList();
    },
    searchStatus(value) {
      this.tableFilter.status = value;
      this.tableFilter.page = 1;
      this.getList();
    },

    getQuery() {
      const query = this.$route.query
      if (Object.keys(query).length > 0) {
        if (this.$validate.DataValid(query.p) && this.$validate.regexNumber(query.p)) {
          this.tableFilter.page = parseInt(query.p)
        }

        if (this.$validate.DataValid(query.l) && this.$validate.regexNumber(query.l)) {
          this.tableFilter.limit = parseInt(query.l)
        }

        if (this.$validate.DataValid(query.q)) {
          this.tableFilter.keyword = query.q
        }

        if (this.$validate.DataValid(query.s)) {
          this.tableFilter.status = query.s
        }
      }
    },
    regenerateURL() {
      const query = this.$route.query
      let q = {
        p: this.tableFilter.limit !== 10 || this.tableFilter.page !== 1 ? this.tableFilter.page : null,
        l: this.tableFilter.limit !== 10 || this.tableFilter.page !== 1 ? this.tableFilter.limit : null,
        q: this.tableFilter.keyword,
        s: this.tableFilter.status
      }
      const newQuery = this.$common.diffQuery(q, query)
      if (newQuery) {
        this.$router.replace({ query: newQuery })
      }
    },
  },

  async mounted() {
    this.getQuery()
    this.getList(false)
  },
}
</script>
